<template>
  <div class="p-grid dashboard">
    <div class="p-col-12">
      <Toast />
      <div class="card">
        <div class="title">Laporan Akumulasi Penjualan Bulanan</div>

        <div class="p-grid p-fluid p-mb-2">
          <div class="p-col-2" style="margin-top: 1.5rem">
            <AutoComplete
              class="p-col"
              placeholder="Pilih Bulan"
              :dropdown="true"
              :suggestions="month_filtered"
              v-model="month"
              @complete="setMonth($event)"
              field="name"
              optionLabel="name"
            >
              <template #item="slotProps">
                <div class="p-col">
                  <div>{{ slotProps.item.name }}</div>
                </div>
              </template>
            </AutoComplete>
          </div>
          <div class="p-col-2" style="margin-top: 1.5rem">
            <AutoComplete
              class="p-col"
              placeholder="Pilih Tahun"
              :dropdown="true"
              :suggestions="year_filtered"
              v-model="year"
              @complete="setYear($event)"
            >
              <template #item="slotProps">
                <div class="p-col">
                  <div>{{ slotProps.item }}</div>
                </div>
              </template>
            </AutoComplete>
          </div>
          <div class="p-col-2" style="margin-top: 2rem">
            <Button
              label="Cari"
              class="p-button-primary"
              icon="pi pi-search"
              @click="getApi()"
            />
          </div>
          <div class="p-col-2" style="margin-top: 2rem" v-if="items != null">
            <router-link
              :to="{
                name: 'print-accumulation-selling-group',
                query: {
                  month: month.id,
                  year: year,
                  outlet_id: user.outlet_id
                }
              }"
              target="_blank"
            >
              <Button
                label="Print"
                icon="pi pi-print"
                class="p-button-success"
              />
            </router-link>
          </div>
          <div class="p-col-2" style="margin-top: 2rem" v-if="items != null">
            <Button
              label="Convert to Excel"
              icon="pi pi-file-excel"
              class="p-button-danger"
              style="color: white"
              @click="convertToExcel"
            />
          </div>
        </div>

        <table style="width: 100%">
          <thead></thead>
          <tbody>
            <div class="p-grid">
              <div class="p-col-12 p-m-auto" id="accumulate"></div>
            </div>
          </tbody>
        </table>
        <div v-if="loading" class="card" style="position: relative">
          <div class="loading-overlay">
            <!-- logo loading -->
            <div class="p-col background-loading">
              <i class="pi pi-spin pi-spinner" style="font-size: 30px"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const moment = require('moment')
import * as XLSX from 'xlsx'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user', 'isAuthenticated'])
  },
  data() {
    return {
      moment: moment,
      loading: false,
      expandedRows: [],
      items: null,
      today: new Date().toISOString().split('T')[0],
      aMonthBefore: new Date(new Date().setDate(new Date().getDate() - 30))
        .toISOString()
        .split('T')[0],
      month: null,
      month_filtered: null,
      months: [
        { id: '1', name: 'Januari' },
        { id: '2', name: 'Februari' },
        { id: '3', name: 'Maret' },
        { id: '4', name: 'April' },
        { id: '5', name: 'Mei' },
        { id: '6', name: 'Juni' },
        { id: '7', name: 'Juli' },
        { id: '8', name: 'Agustus' },
        { id: '9', name: 'September' },
        { id: '10', name: 'Oktober' },
        { id: '11', name: 'November' },
        { id: '12', name: 'Desember' }
      ],
      year: null,
      year_filtered: null,
      years: []
    }
  },
  mounted() {
    this.getAuthUser()
    this.getYears()
  },
  methods: {
    getAuthUser() {
      console.info(this.user)
    },

    getYears() {
      this.$http
        .get(`${process.env.VUE_APP_API_URL}/dashboard/listyear`)
        .then(response => {
          if (response.status === 200) {
            this.years = this.years = response.data.data.years.filter(item => {
              return item >= 2022
            })
          }
        })
    },

    setMonth(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.month_filtered = [...this.months]
        } else {
          this.month_filtered = this.months.filter(item => {
            return item.toLowerCase().startsWith(event.query.toLowerCase())
          })
        }
      }, 250)
    },

    setYear(event) {
      this.year_filtered = this.years.filter(item => {
        return item.toString().startsWith(event.query.toString())
      })
    },

    getApi() {
      document.getElementById('accumulate').innerHTML = ''

      if (this.month == null || this.year == null) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Pilih bulan dan tahun terlebih dahulu',
          life: 3000
        })
        return
      }

      this.loading = true
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/report/monthly-sales?month=${this.month.id}&year=${this.year}`
        )
        .then(response => {
          if (response.status === 200) {
            this.loading = false
            this.items = response.data.data.items
            this.renderTable()
          } else {
            this.loading = false
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Gagal mengambil data',
              life: 3000
            })
          }
        })
    },

    renderTable() {
      let table = ''

      table = `<table style="width: 100%; solid;text-align: center;margin: 0px auto; font-size: 12px;" cellspacing="0" cellpadding="0" border="1">
      <thead>
      <tr>
      <th></th>`
      let panjang = this.items[0].daily_qty.length //<- untuk mendapatkan berapa hari nya nih
      let panjang_kode = this.items.length
      for (let i = 0; i < panjang; i++) {
        table += `
          <th style="text-align: center; font-size: 12px; background: #ddd; width: 50px">${
            i + 1
          }</th>` // <- untuk tanggal nya looping disini
      }
      table += `
      <th style="text-align: center; font-size: 12px; background: #ddd; width: 50px">Total</th>
      <th style="text-align: center; font-size: 12px; background: #ddd; width: 50px">Total Harga</th>
      </tr>
      </thead>
      <tbody>`

      for (let i = 0; i < panjang_kode; i++) {
        table += `
          <tr>
          <td style="text-align: center; font-size: 12px; background: #ddd; font-weight: bold; width: 50px">${this.items[i].cat_code}</td>` // <- untuk kode kategori nya looping disini
        let total_qty = 0
        for (let j = 0; j < panjang; j++) {
          total_qty += this.items[i].daily_qty[j]
          if (this.items[i].daily_qty[j] == '0') {
            table += `
                  <td style="width: 50px">${this.items[i].daily_qty[j]}</td>` // <- untuk jumlah qty nya looping disini
          } else {
            table += `
                  <td style="background: #aaa; width: 50px">${this.items[i].daily_qty[j]}</td>` // <- untuk jumlah qty nya looping disini
          }
        }
        table += `
          <td style="width: 50px">${total_qty}</td>
          <td style="width: 50px">${this.number_format(
            this.items[i].total_rupiah,
            0,
            ',',
            '.'
          )}</td>
            </tr>
          `
      }
      table += `
                </tbody>
                </table>`
      document.getElementById('accumulate').innerHTML = table
    },

    convertToExcel() {
      const table = document.getElementById('accumulate')
      const wb = XLSX.utils.table_to_book(table, { sheet: 'Sheet 1' })
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })

      function s2ab(s) {
        const buf = new ArrayBuffer(s.length)
        const view = new Uint8Array(buf)
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff
        return buf
      }

      const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' })
      const filename = this.month.name + '.xlsx'

      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename)
      } else {
        // Other browsers
        const link = document.createElement('a')
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob)
          link.setAttribute('href', url)
          link.setAttribute('download', filename)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
    },

    number_format(number, decimals, dec_point, thousands_sep) {
      number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
      let n = !isFinite(+number) ? 0 : +number
      let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
      let sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep
      let dec = typeof dec_point === 'undefined' ? '.' : dec_point
      let s = ''

      let toFixedFix = function (n, prec) {
        let k = Math.pow(10, prec)
        return '' + Math.round(n * k) / k
      }

      s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
      if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
      }
      if ((s[1] || '').length < prec) {
        s[1] = s[1] || ''
        s[1] += new Array(prec - s[1].length + 1).join('0')
      }

      return s.join(dec)
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.qty {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 50px;
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

/deep/ .p-datatable.p-datatable-outlets {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-outlets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 5px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.background-loading {
  width: 40px;
  height: 40px;
  margin: auto;
  border-radius: 5px;
  background-color: #eeee;
  margin-top: 0.5%;
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

@media screen and (max-width: 960px) {
  /deep/ .p-datatable {
    &.p-datatable-outlets {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}
::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}
</style>
